import { createSlice } from '@reduxjs/toolkit';

export const newsSlice = createSlice({
  name: 'news',
  initialState: {
    newsId: null,
    newsName: null,
  },
  reducers: {
    setNewsInfo: (state, action) => {
      state.newsId = action.payload.newsId;
      state.newsName = action.payload.newsName;
    },
},
});

export const {setNewsInfo} = newsSlice.actions;

//Selectors
export const selectNewsId = (state) => state.news.newsId;
export const selectNewsName = (state) => state.news.newsName;

export default newsSlice.reducer;